import { Card, CardContent } from '@components/ui/Card';
import SEO from '@components/SEO';

export default function ImpressumPage() {
  return (
    <div className="py-12 bg-slate-950 min-h-screen">
      <SEO
        title="Impressum"
        pathname="/impressum"
        description="Impressum der Sternwarte Mannheim. Angaben gemäß § 5 TMG. Verein Stadtbild Mannheim e.V."
        noindex
      />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-8">Impressum</h1>

        <div className="space-y-6">
          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="space-y-2 text-slate-300">
                <p className="font-semibold">Verein Stadtbild Mannheim e.V.</p>
                <p>Projekt: Aktionsbündnis Alte Sternwarte</p>
                <p>A4,6</p>
                <p>68159 Mannheim</p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">Kontakt</h2>
              <div className="space-y-2 text-slate-300">
                <p>
                  E-Mail:{" "}
                  <a
                    href="mailto:kontakt@sternwarte-mannheim.de"
                    className="text-blue-400 hover:text-blue-300 transition-colors"
                  >
                    kontakt@sternwarte-mannheim.de
                  </a>
                </p>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">
                Verantwortlich für den Inhalt
              </h2>
              <p className="text-slate-300">
                Verein Stadtbild Mannheim e.V. - Aktionsbündnis Alte Sternwarte
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">Haftungshinweis</h2>
              <p className="text-slate-300 leading-relaxed">
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
                Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
                deren Betreiber verantwortlich.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold text-white mb-4">Urheberrecht</h2>
              <p className="text-slate-300 leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
